<template>
    <div id="member">
        <!-- PC端内容 -->
        <div class="page flex-col" v-if="!isMobile">
            <div class="box_1 flex-col">
                <div class="p_img">
                    <a href="javascript:;">
                        <img src="../../../assets/client/banner_9.png" alt="分子公司" title="分子公司">
                    </a>
                </div>
                <div class="p_info">
                    <div>
                        <h2 class="text-white p_btitle">分子公司</h2>
                        <h6 class="text-white p_subtitle">SAILHERO&nbsp;ENVIRONMENTAL&nbsp;PROTECTION</h6>
                    </div>
                </div>
            </div>
            <div class="box_3 flex-col justify-end">
                <div class="group_2 flex-row">
                    <div class="text-wrapper_1 flex-col justify-between">
                        <span class="text_13">当前位置：首页&nbsp;&gt;&nbsp;分子公司</span>
                        <span class="text_14">分子公司</span>
                    </div>
                    <div class="text-wrapper_6_be">
                        <transition  name="slide">
                            <div class="text-wrapper_2 flex-col" v-if="telshow">
                                <span class="text_15">4001-300-137</span>
                            </div>
                        </transition>
                    </div>
                    <div class="box_8_1">
                        <div class="block_1 flex-row" style="cursor:pointer" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
                            <div class="image-text_1 flex-col justify-between">
                                <img class="label_1" referrerpolicy="no-referrer" src="../../../assets/client/icon_lxfs.png" />
                                <span class="text-group_1">业务咨询</span>
                            </div>
                        </div>
                    </div>
                </div>
                <img class="image_2" referrerpolicy="no-referrer" src="../../../assets/client/dx_1.jpg" />
                <span class="paragraph_1">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;二十余年来，先河环保从单一的监测领域，迅速扩展至生态环境监测装备、VOCs治理、环境大数据分析决策支持服务、运维服务、社会化检测、农村污水治理六大模块；从拥有北京绿源先河、上海绿源先河两家子公司，扩充到现在的国内外15家子公司。
                    <br /><br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;新起点，新征程。先河未来将继续通过资本运作，深耕国内市场，布局全球战略，打造国际化、集团化的高科技上市公司，打造一个让用户满意、社会尊重、员工自豪、良性发展的世界级民族品牌！
                </span>
                <img class="image_3" referrerpolicy="no-referrer" src="../../../assets/client/ds_4.jpg" />
                <div class="group_3 flex-col justify-end">
                    <div class="grid_1 flex-row">
                        <div class="section_2 flex-col" v-for="(item,index) in Member" @click="clickMember(item.id)" :style="{marginRight:(index+1)%4==0?'0':null}">
                            <img class="image_4" referrerpolicy="no-referrer" :src="FileAddress+item.FilePath" @load="resizeImage"/>
                            <span class="text_16">{{item.full_name}}</span>
                            <span class="paragraph_2" v-html="item.company_desc.replace(/<[^>]*>/g, '')"></span>
                            <img class="label_2" referrerpolicy="no-referrer" src="https://lanhu-oss.lanhuapp.com/SketchPng2802131b1b30253a29d9861328fb370fab10c9b7013f962d758821d0954b8fd7" />
                        </div>
                    </div>
                    <div class="text-wrapper_5 flex-col"></div>
                </div>
            </div>
        </div>

        <!-- 移动端内容 -->
        <div class="mobile-member-container" v-if="isMobile">
            <!-- Banner区域 -->
            <div class="mobile-member-banner">
                <img class="mobile-member-banner__image" src="../../../assets/client/banner_9.png" alt="分子公司" />
                <div class="mobile-member-banner__overlay"></div>
                <div class="mobile-member-banner__content">
                    <h1 class="mobile-member-banner__title">分子公司</h1>
                    <p class="mobile-member-banner__subtitle">SAILHERO ENVIRONMENTAL PROTECTION</p>
                </div>
            </div>

            <!-- 面包屑导航 -->
            <div class="mobile-member-breadcrumb">
                <p class="mobile-member-breadcrumb__text">
                    首页 > <span class="mobile-member-breadcrumb__current">分子公司</span>
                </p>
            </div>

            <!-- 公司简介 -->
            <div class="mobile-member-intro">
                <p class="mobile-member-intro__text">
                    二十余年来，先河环保从单一的监测领域，迅速扩展至生态环境监测装备、VOCs治理、环境大数据分析决策支持服务、运维服务、社会化检测、农村污水治理六大模块；从拥有北京绿源先河、上海绿源先河两家子公司，扩充到现在的国内外15家子公司。
                </p>
                <p class="mobile-member-intro__text">
                    新起点，新征程。先河未来将继续通过资本运作，深耕国内市场，布局全球战略，打造国际化、集团化的高科技上市公司，打造一个让用户满意、社会尊重、员工自豪、良性发展的世界级民族品牌！
                </p>
                <img class="mobile-member-intro__image" src="../../../assets/client/ds_4.jpg" alt="分子公司" />
            </div>

            <!-- 分子公司卡片列表 -->
            <div class="mobile-member-cards">
                <div 
                    class="mobile-member-card" 
                    v-for="(item, index) in Member" 
                    :key="item.id"
                    @click="clickMember(item.id)"
                >
                    <div class="mobile-member-card__logo-wrapper">
                        <img 
                            class="mobile-member-card__logo" 
                            :src="FileAddress + item.FilePath" 
                            :alt="item.full_name"
                        />
                    </div>
                    <h3 class="mobile-member-card__name">{{ item.full_name }}</h3>
                    <p class="mobile-member-card__desc" v-html="item.company_desc.replace(/<[^>]*>/g, '')"></p>
                    <img 
                        class="mobile-member-card__arrow" 
                        src="../../../assets/client/youjiantou.png" 
                        alt="查看详情"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import "../../../assets/client/member.css";
import "../../../assets/client/member-mobile.css";
export default{
    data(){
        return {
            form: {
                pageSize: -1,
                pageIndex: -1,
                sort:""
            },
            FileAddress: process.env.VUE_APP_FileAddress.replace('fileapi/', ''),
            Member: [],
            telshow:false,
            isMobile: false,
            lastDeviceType: null,
        }
    },
    methods:{
        getDataList() {
            let that = this;
            that.$api.post("/Client/getMamberData", that.form,
                function (res) {
                    that.Member = [];
                    if (res.code === "200") {
                        that.Member = res.data;
                    }
                },
                function (res) {
                    //that.$message.error("服务器异常，删除出错");
                }
            );
        },
        clickMember(id) {
            this.$parent.toLink("/Client/MemberInfo?id=" + id, "");
        },
        resizeImage(event) {
            const img = event.target;
            const width = img.naturalWidth;
            const height = img.naturalHeight;
            img.style.width = `${width}px`;
            img.style.height = `${height}px`;
        },
        handleMouseEnter(){
        let that = this;
        that.telshow = true;
        },
        handleMouseLeave(){
            let that = this;
            that.telshow = false;
        },
        checkMobile() {
            const wasMobile = this.isMobile;
            this.isMobile = window.innerWidth <= 768;
            
            // 检测设备类型变化
            const currentDeviceType = this.isMobile ? 'mobile' : 'pc';
            if (this.lastDeviceType && this.lastDeviceType !== currentDeviceType) {
                // 设备类型发生了变化，需要重新加载数据
                this.getDataList();
            }
            this.lastDeviceType = currentDeviceType;
        }
    },
    mounted(){
        this.getDataList();
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkMobile);
    },
    watch:{ }
}
</script>
<style scoped>
      .slide-enter-active, .slide-leave-active {
        transition: transform 0.5s;
    }
    .slide-enter, .slide-leave-to /* .slide-leave-active for <2.1.8 */ {
        transform: translateX(22.53vw);
    }

    .p_img img {
        height: 100%;
        width: 100%;
        object-fit: cover;
        animation: bannerimg 2s;
    }

    .p_info .p_btitle {
        animation: puBanner 1s;
        color: #FFF;
        font-size: 59px;
        font-weight: 900;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .p_info .p_subtitle {
        animation: puBanner 1s;
        color: #FFF;
        font-size: 1.458333vw;
        font-weight: 400;
        position: relative;
        bottom: 3.125vw;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        letter-spacing: 0.05625vw;
    }

    .p_info {
        width: 100%;
        max-width: 1600px;
        padding: 0 5px;
        position: absolute;
        left: 257px;
        top: 120px;
        letter-spacing: 3px;
        z-index: 9;
    }

    @keyframes puBanner {
        from {
            transform: translateY(200px);
            opacity: 0
        }

        to {
            transform: translateY(0);
            opacity: 1
        }
    }

    @keyframes bannerimg {
        from {
            transform: scale(1.15)
        }

        to {
            transform: scale(1);
        }
    }
</style>
